"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var helpers_1 = require("./helpers");
var Button_1 = require("../../Button");
var Checkbox_1 = require("../Checkbox");
var ControlSeparator_1 = require("../ControlSeparator");
var StackView_1 = require("../../StackView");
var Tooltip_1 = require("../../Tooltip");
var Text_1 = require("../../Text");
var helpers_2 = require("../../Grid/cellRenderers/helpers");
var StyledCheckbox = styled_components_1.default(Checkbox_1.Checkbox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n"], ["\n    width: 100%;\n"])));
var ItemBox = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    max-width: ", ";\n"], ["\n    max-width: ", ";\n"])), helpers_1.DEFAULT_MAX_WIDTH_COLUMN);
function Item(_a) {
    var data = _a.data, selected = _a.selected, onToggle = _a.onToggle, rest = __rest(_a, ["data", "selected", "onToggle"]);
    var ref = react_1.useRef(null);
    return Tooltip_1.useTooltip({
        delayTimeout: 500,
        maxWidth: helpers_1.DEFAULT_MAX_WIDTH_COLUMN,
        renderContent: function () { return react_1.default.createElement(helpers_2.TooltipText, { size: Text_1.TEXT_SIZE.s }, data.label); },
        render: function (tooltipProps) {
            return (react_1.default.createElement(ItemBox, null,
                react_1.default.createElement(StyledCheckbox, { "data-selector-id": rest['data-selector-id'], checked: selected, labelTruncate: true, onChange: function () { return onToggle && onToggle(data.value); }, onMouseEnter: helpers_2.onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave, ref: ref }, data.label)));
        }
    });
}
var TitleGroup = styled_components_1.default(Text_1.Text)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    height: ", "px;\n    line-height: ", "px;\n"], ["\n    height: ", "px;\n    line-height: ", "px;\n"])), helpers_1.INT_HEIGHT_FOOTER_MENU, helpers_1.INT_HEIGHT_FOOTER_MENU);
var WrapperGroup = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var WrapperContent = styled_components_1.default(StackView_1.StackView)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    max-height: ", ";\n    overflow-y: auto;\n"], ["\n    max-height: ", ";\n    overflow-y: auto;\n"])), helpers_1.DEFAULT_MAX_HEIGHT_COLUMN);
function Content(_a) {
    var groups = _a.groups, onToggleItem = _a.onToggleItem, isSelected = _a.isSelected;
    return (react_1.default.createElement(WrapperContent, { gap: StackView_1.STACK_GAP.xs, direction: StackView_1.STACK_DIRECTION.column }, groups.map(function (_a, groupKey) {
        var titleGroup = _a.title, items = _a.items;
        return (react_1.default.createElement(WrapperGroup, { key: "wrapper-group-" + groupKey },
            react_1.default.createElement(TitleGroup, { size: Text_1.TEXT_SIZE.m, weight: Text_1.TEXT_WEIGHT.bold }, titleGroup),
            items.map(function (item, optionKey) {
                return (react_1.default.createElement(Item, { key: groupKey + "-" + optionKey, "data-selector-id": item.testId ||
                        helpers_1.dataSelectorId.partIdCheckbox + "-" + groupKey + "-" + optionKey, data: item, selected: isSelected(item.value), onToggle: onToggleItem }));
            })));
    })));
}
function CategorizeContentContent(_a) {
    var groups = _a.groups, canSelectAll = _a.canSelectAll, canClearAll = _a.canClearAll, onSelectAll = _a.onSelectAll, onClearAll = _a.onClearAll, onToggleItem = _a.onToggleItem, isSelected = _a.isSelected, texts = _a.texts;
    return (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.column },
        react_1.default.createElement(Content, { groups: groups, onToggleItem: onToggleItem, isSelected: isSelected }),
        react_1.default.createElement(StackView_1.StackView, { gap: StackView_1.STACK_GAP.m, align: StackView_1.STACK_ALIGN.center },
            react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.text, disabled: !canSelectAll, onClick: onSelectAll, "data-selector-id": helpers_1.dataSelectorId.selectAll }, texts.selectAll),
            react_1.default.createElement(ControlSeparator_1.ControlSeparator, null),
            react_1.default.createElement(Button_1.Button, { ui: Button_1.BUTTON_VIEW.text, disabled: !canClearAll, onClick: onClearAll, "data-selector-id": helpers_1.dataSelectorId.clearAll }, texts.clearAll))));
}
exports.CategorizeContentContent = CategorizeContentContent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=CategorizeContentContent.js.map